export default "__VITE_ASSET__CidXNBTc__"